import classNames from 'classnames';
import Flex from '../../../../components/common/Flex';
import React, { useEffect } from 'react';
import { Card, Col, ProgressBar, Row, Modal, CloseButton, Button } from 'react-bootstrap';
import HalfDoughnutChart from './graph-usability/half-doughnut-chart';
import CountUp from 'react-countup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SubtleBadge from './graph-usability/subtle-badge';
import { iconPunto, iconPuntoF, iconPuntoI } from '../../../../components/common/google-maps-selector/GoogleMapSelector';
import reporteTiempoStore from '../../../../lib/store/reporte_tiempo_store';

const CardVehicles = ({ totalOnMain, totalOffMain }) => {

    const store = reporteTiempoStore();

    const listVM = Object.values(store.listaReporte).map((vehicle, index) => ({
        id: index,
        title: vehicle.title,
        totalAlerts: vehicle.totalAlerts,
        totalRecords: vehicle.totalRecords, //Total filas  
        totalTime: vehicle.totalTime, //Tiempo total
        totalDistance: vehicle.totalDistance, //Distancia recorrida 
        totalIgnition: vehicle.totalIgnition, //Total encendido
        totalStopped: vehicle.totalStopped, //Total detenido
        totalOff: vehicle.totalOff, // Total Apagado
        totalLitters: vehicle.totalLitters, //Total litros 
        AllHours: vehicle.AllHours,
        progress: 0,
        markers: vehicle.markers, //Detallado de puntos 
        color: ['primary', 'success', 'warning', 'danger', 'info'][index % 5] // Alternar colores
    }));

    if (listVM.length === 0) {
        return <></>;
    } else {
        const allHours = (listVM.reduce((a, v) => a = a + v.AllHours, 0));
        const globalIgnitionTime = totalOnMain;//(listVM.reduce((a, v) => a = a + v.totalTime, 0));
        const globalStopEngineTime = totalOffMain;//(listVM.reduce((a, v) => a = a + v.totalStopped, 0));
        const totalOn = (globalIgnitionTime + globalStopEngineTime);
        const pocentDbl = Math.round((totalOn / allHours) * 100);
        const nowPorcent = isNaN(pocentDbl) ? 0 : parseInt(pocentDbl);
        const nowMax = (100 - nowPorcent) <= 100 ? 100 - nowPorcent : 0;


        const formattedData = Object.values({
            'Tiempo en movimientos': { title: 'Tiempo en movimientos', color: '#008001', percent: (globalIgnitionTime / allHours) * 100 },
            'Tiempo detenido': { title: 'Tiempo detenido', color: '#ffcb05', percent: (globalStopEngineTime / allHours) * 100 },
        });
        return (
            <Col md={12}>

                <Row>
                    <Col md={12}>
                        <Card className='mb-3'>
                            <Card.Body>
                                <Row className='py-2'>

                                    <div style={{ width: '10.625rem' }}>
                                        <div
                                            className="text-center"
                                            style={{ width: '10.625rem' }}
                                        >
                                            <span className="mb-2 text-primary" style={{ fontWeight: 'bold' }}>Usabilidad de flota</span>
                                            <Col className="my-n4">
                                                <div className="mb-n6">
                                                    <HalfDoughnutChart
                                                        color={nowPorcent <= 100 ? "primary" : "danger"}
                                                        target={100}
                                                        reached={nowPorcent}

                                                    />
                                                </div>
                                                <CountUp
                                                    start={0}
                                                    end={(nowPorcent).toFixed(0)}
                                                    duration={2.75}
                                                    style={{ fontWeight: 'bold', fontSize: '125%', color: '#212121' }}
                                                    suffix="%"
                                                    separator=","
                                                />
                                            </Col>
                                        </div>
                                    </div>
                                    <Col className='mx-4'>
                                        <Row>
                                            <Col md={4} className='py-md-4 justify-content-center'>
                                                <Row className='flex-row flex-nowrap'>
                                                    <Col className='text-center text-primary'>
                                                        <span style={{ fontWeight: 'bold', fontSize: '125%' }}>{(allHours * (nowPorcent / 100)).toFixed(0)} hr(s)</span>
                                                        {/* <SubtleBadge pill bg="success" className='mx-2 '>
                                                            <FontAwesomeIcon icon="caret-up" className="me-1" />
                                                            {nowPorcent} {' %'}
                                                        </SubtleBadge> */}
                                                    </Col>
                                                </Row>
                                                <Row className='px-3 justify-content-center py-2 label-detail-card'>
                                                    Total Horas Laborales Productivas
                                                </Row>
                                            </Col>
                                            <Col md={4} className='py-md-4 justify-content-center'>
                                                <Row className='px-3 justify-content-center text-primary' style={{ fontWeight: 'bold' }}>
                                                    {(allHours).toFixed(0)} hr(s)
                                                </Row>
                                                <Row className='px-3 justify-content-center py-2 label-detail-card'>
                                                    Total Horas Laborales Configuradas
                                                </Row>
                                                <Row className='px-3 justify-content-center py-2 small text-primary'>
                                                    {store.vehiculoSinHorario === 0 ?
                                                        <>
                                                            {<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                title='(Ninguna unidad cuenta con horas laborales configuradas)'
                                                            >
                                                                Ninguna unidad cuenta con horas laborales configuradas
                                                            </div>}
                                                            <a className='text-center' href='https://gps.quro.com.mx/Configuracion?windowId=2' size="sm" >
                                                                Ir a configuraci&oacute;n de horario
                                                            </a>
                                                        </> :
                                                        store.vehiculoSinHorario === (store.vehiculos.length) ?
                                                            <>
                                                                {<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                    {'(Todas las unidades cuentan con horas laborales configuradas)'}
                                                                </div>}
                                                            </> :
                                                            <>
                                                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} >
                                                                    {'(Algunas unidades no cuentan con horas laborales configuradas)'} </div>
                                                                <a className='text-center' href='https://gps.quro.com.mx/Configuracion?windowId=2' size="sm" >
                                                                    Ir a configuraci&oacute;n de horario
                                                                </a>
                                                            </>
                                                    }
                                                </Row>
                                            </Col>
                                            <Col md={4} className='py-md-4' >{/*</Row>title={store.vehiculos.map(w => w.label).join(", ")}>*/}
                                                <Row className='px-3 justify-content-center text-primary' style={{ fontWeight: 'bold' }}>
                                                    {store.listaTabla.length}
                                                </Row>
                                                <Row className='px-3 justify-content-center py-2 label-detail-card'>
                                                    Vehículos Analizados
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className='py-2'>
                                    {formattedData.map((group, index) => (
                                        <Col
                                            xs={6}
                                            sm="auto"
                                            as={Flex}
                                            alignItems="center"
                                            className="pe-2 text-small-estadias"
                                            key={group.title}
                                            style={{ fontWeight: 'bold' }}
                                        >
                                            <span
                                                className="dot"
                                                style={{ backgroundColor: index !== 0 ? group.color : group.percent <= 100 ? group.color : '#e63757', width: 10, height: 10, borderRadius: '50%', display: 'inline-block', marginRight: 5 }}
                                            ></span>
                                            <span> {group.title}</span>
                                            <span className="ms-1">({`${(group.percent).toFixed(0)}%`})</span>
                                        </Col>
                                    ))}
                                    <Col
                                        className="pe-2 text-small-estadias text-start"
                                        key={'Tiempo sin actividad'}
                                        style={{ fontWeight: 'bold' }}
                                    >
                                        <span
                                            className="dot"
                                            style={{ backgroundColor: "#db8049", width: 10, height: 10, borderRadius: '50%', display: 'inline-block', marginRight: 5 }}
                                        ></span>
                                        <span>Tiempo motor apagado </span>
                                        <span className="ms-1">({`${(nowMax).toFixed(0)}%`})</span>
                                    </Col>
                                </Row>
                                <ProgressBar
                                    style={{ height: 15 }}
                                    className="usability-progress shadow-none rounded-4 mb-3"
                                    variant='success'>
                                    {formattedData.map((group, index) => (
                                        <ProgressBar
                                            style={{ backgroundColor: index !== 0 ? group.color : group.percent <= 100 ? group.color : '#e63757' }}
                                            now={group.percent}
                                            key={group.title}
                                            className={classNames('overflow-visible position-relative', {
                                                'rounded-end rounded-pill': index === 0,
                                                'rounded-start rounded-pill': index === formattedData.length - 1,
                                                'border-end border-100 border-2': index !== formattedData.length - 1,
                                                'rounded-0': index !== formattedData.length - 1 && index !== 0
                                            })}
                                        />
                                    ))}
                                </ProgressBar>
                                <div className='pt-2 label-detail-card'>
                                    Porcentaje de usabilidad en base a las horas encendido vs horas laborales establecidas
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row >

            </Col>
        );
    }
}

export default CardVehicles;